"use client";
import * as React from 'react';
import { Accordion, AccordionItem } from '@/components/ui/accordion';
import { faqPageSchema } from '@/lib/schema';

export function FAQAccordion({
  faqs,
  title = 'Frequently Asked Questions',
}: {
  faqs: { question: string; answer: string }[];
  title?: string;
}) {
  const schema = faqPageSchema(faqs);
  return (
    <section className="container py-12">
      <h2 className="text-2xl md:text-3xl font-semibold dark-text">{title}</h2>
      <div className="mt-6">
        <Accordion>
          {faqs.map((faq) => (
            <AccordionItem key={faq.question} title={faq.question}>
              <p className="text-sm text-gray-700">{faq.answer}</p>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </section>
  );
}
